import axios from "axios";

import {OPK_SET_LOADING, OPK_ERROR, GET_OPK, PUT_OPK, DELETE_OPK, GET_GROUP_CODE_5, GET_CALC_SETTINGS, PUT_CALC_SETTINGS, SET_LOADING_CALC_SETTINGS, CALC_ERROR} from './types'
import {POST_OPK} from "./actions";
const token =  localStorage.getItem("token");
const headers =  {
  'Accept': "application/json",
  "Content-Type": "application/json",
  "Authorization":`JWT ${token}`
}

export const getGroupCode5 = () => async (dispatch) => {
    dispatch({ type: OPK_SET_LOADING })

    const config = {
    headers: {
        'Content-Type': 'application/json',
    },
  };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
    const response = await axios.get(`${process.env.REACT_APP_API}groupcode5/`, config);

    dispatch({
      type: GET_GROUP_CODE_5,
      payload: response.data
    })

  } catch (err) {
    console.log("error: ", JSON.stringify(err))
    dispatch({ type: OPK_ERROR })
  }
}
// getopk list
export const getOPK = (params) => async (dispatch) => {
    dispatch({ type: OPK_SET_LOADING })

    const config = {
      headers: headers,
      method: "get",
      url: `/api/opk/listed/`,
      params: params,
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
    const response = await axios(config);

    dispatch({
      type: GET_OPK,
      payload: response.data
    })

  } catch (err) {
    console.log("error: ", JSON.stringify(err))
    dispatch({ type: OPK_ERROR })
  }
}

export const putOPK = (opkID, opkFormData) => async (dispatch) => {
    dispatch({ type: OPK_SET_LOADING })

    const config = {
    headers: {
        'Content-Type': 'application/json',
    },
  };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try { 
    let response = await axios.put(`${process.env.REACT_APP_GET_OPK}${opkID}/`, opkFormData, config);
    response.data.id = opkID;
    dispatch({
      type: PUT_OPK,
      payload: response.data,
    })

  } catch (err) {
    console.log("error: ", JSON.stringify(err))
    dispatch({ type: OPK_ERROR })
  }
}

export const postOPK = (opkFormData) => async (dispatch) => {
    dispatch({ type: OPK_SET_LOADING })

    const config = {
    headers: {
        'Content-Type': 'application/json',
    },
  };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
    const response = await axios.post(`${process.env.REACT_APP_GET_OPK}`, opkFormData, config);

    dispatch({
      type: POST_OPK,
      payload: response.data
    })

  } catch (err) {
    console.log("error: ", JSON.stringify(err))
    dispatch({ type: OPK_ERROR })
  }
}

export const deleteOPK = (opkID) => async (dispatch) => {
  dispatch({ type: OPK_SET_LOADING })

  console.log("opkID: ", opkID)

  const config = {
    headers: {
        'Content-Type': 'application/json',
    },
  };
  config.headers.Authorization = "JWT " + localStorage.getItem("token");

  try { 
    let response = await axios.delete(`${process.env.REACT_APP_GET_OPK}${opkID}/`, config);
    
    dispatch({
      type: DELETE_OPK,
      payload: opkID
    })

  } catch (err) {
    console.log("error: ", JSON.stringify(err))
    dispatch({ type: OPK_ERROR })
  }
}

export const getCalcSettings = () => async (dispatch) => {
  const config = {
    headers: headers,
    method: "get",
    url: `/api/calc_settings/my/`,
  };
  config.headers.Authorization = "JWT " + localStorage.getItem("token");

  try {
  const response = await axios(config);

  dispatch({
    type: GET_CALC_SETTINGS,
    payload: response.data
  })

} catch (err) {
  console.log("error: ", JSON.stringify(err))
}
}

export const putCalcSettings = (id, settings) => async (dispatch) => {
  dispatch({ type: SET_LOADING_CALC_SETTINGS })
  const config = {
    headers: headers,
    method: "put",
    url: `/api/calc_settings/${id}/`,
    data: settings
  };
  config.headers.Authorization = "JWT " + localStorage.getItem("token");

  try {
  const response = await axios(config);

  dispatch({
    type: PUT_CALC_SETTINGS,
    payload: response.data
  })

} catch (err) {
  console.log("error: ", JSON.stringify(err))
  dispatch({ type: CALC_ERROR })
}
}
